export const withSpinning = (duration, clockwise = true) => ({
  animationName: {
    from: {
      transform: 'rotate(0deg)',
    },
    to: {
      transform: `rotate(${clockwise ? '+' : '-'}359deg)`,
    },
  },
  animationDuration: `${duration}ms`,
  animationIterationCount: 'infinite',
  animationTimingFunction: 'linear',
});
